import { p as proxyCustomElement, H, d as createEvent, h } from './p-23afa4c1.js';
import { d as defineCustomElement$1 } from './p-8938db8f.js';
import { b as bem } from './p-a05fe53c.js';
import { C as CSSTransition } from './p-356d8deb.js';
import { r as resolveAppearance } from './p-d1ae9dd0.js';
import { g as global } from './p-4ff03e8a.js';

const hasReducedMotion = () => {
    return global.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

const cosmosMediaPreviewCss = ":host{display:-ms-flexbox;display:flex;overflow:hidden}.cosmos-media-preview{-ms-flex-positive:1;flex-grow:1;overflow:hidden;-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0)}.cosmos-media-preview--radius-none{border-radius:var(--cosmos-media-preview-border-radius, 0)}.cosmos-media-preview--radius-small{border-radius:var(--cosmos-media-preview-border-radius, 2px)}.cosmos-media-preview--radius-medium{border-radius:var(--cosmos-media-preview-border-radius, 6px)}.cosmos-media-preview--radius-large{border-radius:var(--cosmos-media-preview-border-radius, 8px)}.cosmos-media-preview--radius-full{border-radius:var(--cosmos-media-preview-border-radius, 9999px)}.cosmos-media-preview__container{-ms-flex-positive:1;flex-grow:1;height:100%;overflow:hidden;-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);-webkit-transition:-webkit-transform 0.6s cubic-bezier(0.35, 0, 0, 1);transition:-webkit-transform 0.6s cubic-bezier(0.35, 0, 0, 1);transition:transform 0.6s cubic-bezier(0.35, 0, 0, 1);transition:transform 0.6s cubic-bezier(0.35, 0, 0, 1), -webkit-transform 0.6s cubic-bezier(0.35, 0, 0, 1);width:100%}.cosmos-media-preview--active .cosmos-media-preview__container{-webkit-transform:scale(1.04) translate3d(0, 0, 0);transform:scale(1.04) translate3d(0, 0, 0)}.cosmos-media-preview__image{height:100%}.cosmos-media-preview__video{display:block;height:100%;left:0;-o-object-fit:cover;object-fit:cover;opacity:0;position:absolute;top:0;width:100%;z-index:4}.cosmos-media-preview__video--visible{opacity:1}.cosmos-media-preview__video.enter{opacity:0;-webkit-transition:0.2s ease-in;transition:0.2s ease-in}.cosmos-media-preview__video.enter-active{opacity:1}.cosmos-media-preview__video.leave{opacity:1;-webkit-transition:0.2s ease-in;transition:0.2s ease-in}.cosmos-media-preview__video.leave-active{opacity:0}";
const CosmosMediaPreviewStyle0 = cosmosMediaPreviewCss;

const generateClassNames = bem('cosmos-media-preview');
const CosmosMediaPreview = /*@__PURE__*/ proxyCustomElement(class CosmosMediaPreview extends H {
    handleVideoChange() {
        this.canPlayThroughVideo = false;
    }
    handleAppearanceChange(appearance) {
        this.computedAppearance = appearance;
    }
    handleActiveChange(newValue) {
        if (newValue) {
            this.startVideo();
        }
        else {
            this.stopVideo();
        }
    }
    handlePlayVideoChange(newValue) {
        if (newValue) {
            this.startVideo();
        }
        else {
            this.stopVideo();
        }
    }
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.resizeEvent = createEvent(this, "resize", 5);
        this.handleImageResize = ({ detail: { height, width } }) => {
            this.resizeEvent.emit({
                height,
                width,
            });
        };
        this.handleCanPlayThrough = () => {
            if (!this.canPlayThroughVideo) {
                this.canPlayThroughVideo = true;
                if (this.isVideoPlaying) {
                    this.showVideo();
                }
            }
        };
        this.handleVideoCompletion = async () => {
            await this.hideVideo();
        };
        this.active = undefined;
        this.appearance = undefined;
        this.image = undefined;
        this.imageAlt = undefined;
        this.imagePreview = undefined;
        this.loading = undefined;
        this.observeResize = undefined;
        this.playVideo = undefined;
        this.radius = 'none';
        this.sizes = undefined;
        this.srcset = undefined;
        this.video = undefined;
        this.canPlayThroughVideo = false;
        this.computedAppearance = 'light';
        this.isVideoPlaying = false;
        this.isVideoVisible = false;
        this.cssTransition = new CSSTransition();
    }
    componentWillLoad() {
        resolveAppearance({
            instance: this,
            modeToAppearanceMap: { dark: 'dark', light: 'light' },
            callback: this.handleAppearanceChange.bind(this),
        });
        if (this.playVideo || this.active) {
            this.startVideo();
        }
    }
    async startVideo() {
        if (!this.canHandleVideo()) {
            return;
        }
        this.isVideoPlaying = true;
        await this.showVideo();
        this.videoElement.play();
    }
    async stopVideo() {
        if (!this.canHandleVideo()) {
            return;
        }
        await this.hideVideo();
        this.isVideoPlaying = false;
        this.videoElement.pause();
        this.videoElement.currentTime = 0;
    }
    async showVideo() {
        if (this.canPlayThroughVideo) {
            this.isVideoVisible = true;
            await this.cssTransition.enter(this.videoElement, 200);
        }
    }
    async hideVideo() {
        this.isVideoVisible = false;
        await this.cssTransition.leave(this.videoElement, 200);
    }
    canHandleVideo() {
        return !!this.video && !hasReducedMotion();
    }
    render() {
        return (h("div", { key: 'dff1cfc443ad5a790eaf84b402cfbff074d08b8a', class: generateClassNames({
                active: this.active,
                appearance: this.computedAppearance,
                radius: this.radius,
            }), part: "base" }, h("div", { key: 'dc458da8312a3e56e4adecd350a9ba210a5d6f0b', class: generateClassNames('container') }, h("cosmos-image", { key: '7ccdb778a4a9aeefc3e6df8dce38cd05a6fd45a8', class: generateClassNames('image'), image: this.image, imagePreview: this.imagePreview, imageAlt: this.imageAlt, appearance: this.appearance, observeResize: this.observeResize, onResize: this.handleImageResize, loading: this.loading, sizes: this.sizes, srcset: this.srcset }), this.video && (h("video", { class: generateClassNames('video', { visible: this.isVideoVisible && this.isVideoPlaying }), ref: (el) => (this.videoElement = el), src: this.video, muted: true, preload: "none", playsInline: true, onCanPlayThrough: this.handleCanPlayThrough, "aria-hidden": "true", onEnded: this.handleVideoCompletion })))));
    }
    get element() { return this; }
    static get watchers() { return {
        "video": ["handleVideoChange"],
        "appearance": ["handleAppearanceChange"],
        "active": ["handleActiveChange"],
        "playVideo": ["handlePlayVideoChange"]
    }; }
    static get style() { return CosmosMediaPreviewStyle0; }
}, [1, "cosmos-media-preview", {
        "active": [516],
        "appearance": [513],
        "image": [513],
        "imageAlt": [513, "image-alt"],
        "imagePreview": [513, "image-preview"],
        "loading": [513],
        "observeResize": [516, "observe-resize"],
        "playVideo": [516, "play-video"],
        "radius": [513],
        "sizes": [513],
        "srcset": [513],
        "video": [513],
        "canPlayThroughVideo": [32],
        "computedAppearance": [32],
        "isVideoPlaying": [32],
        "isVideoVisible": [32]
    }, undefined, {
        "video": ["handleVideoChange"],
        "appearance": ["handleAppearanceChange"],
        "active": ["handleActiveChange"],
        "playVideo": ["handlePlayVideoChange"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-media-preview", "cosmos-image"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-media-preview":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosMediaPreview);
            }
            break;
        case "cosmos-image":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}

export { CosmosMediaPreview as C, defineCustomElement as d };
